import React from "react"
import PropTypes from "prop-types"
import { track } from "lib/analytics"

const GOOGLE_ANALYTICS_CATEGORY = "Admin Topbar Menu"
const GOOGLE_ANALYTICS_ACTION = "Click"

const AdminAction = ({ path, icon, label, trackAction }) => {
  const iconElement = icon ? <i className={`icon-${icon}`} /> : null
  const onClick = () => track(GOOGLE_ANALYTICS_CATEGORY, GOOGLE_ANALYTICS_ACTION, trackAction)

  return (
    <li key={path}>
      <a href={path} onClick={onClick}>
        {iconElement}
        {label}
      </a>
    </li>
  )
}

AdminAction.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  trackAction: PropTypes.string.isRequired,
}

AdminAction.defaultProps = {
  icon: undefined,
}

export default AdminAction
